"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
class PulseEventModel {
    store;
    constructor(eventModel) {
        this.store = new Map((0, lodash_1.toPairs)(eventModel));
    }
    setSpid(spid) {
        return this;
    }
    setProduct(productName) {
        const origin = this.store.get('origin') || {};
        const custom = origin['spt:custom'] || {};
        custom['spt:product'] = productName;
        origin['spt:custom'] = custom;
        this.store.set('origin', origin);
        return this;
    }
    ;
    set deployStage(target) {
        this.store.set('deployStage', target);
    }
    set deployTag(tag) {
        this.store.set('deployTag', tag);
    }
    get object() {
        return this.store.get('object');
    }
    get type() {
        return this.store.get('type');
    }
    toObject() {
        const obj = {};
        this.store.forEach((v, k) => {
            if (v instanceof PulseEventModel) {
                obj[k] = v.toObject();
            }
            else {
                obj[k] = v;
            }
        });
        return obj;
    }
}
exports.default = PulseEventModel;
